<div id="map"
     leaflet
     (leafletMapReady)="onMapReady($event)"
     [leafletOptions]="mapOptions">
</div>